interface EmptyStateProps {
  message?: string;
}

const EmptyState = ({ message = "No data available." }: EmptyStateProps) => (
  <div className="flex items-center justify-center py-16">
    <p className="text-[14px] font-medium text-content-label">
      {message}
    </p>
  </div>
);

export default EmptyState;
